/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_overlayopening = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		/*
		Button: Start Tour
		*/
		$(document).on('click','.js-starttour',function() {
			specific_overlayopening.start();
		});

		/*
		Button: Close popup
		*/
		$(document).on('click','.js-starttour-now',function() {
			popup.close();
		});

		if(
			url[1] == 'akkers-in-nuenen' &&
			url[2] == '' ||
			url[1] == 'akkers-in-nuenen' &&
			url[2] == '1' &&
			isFirstLoad == 1
		) {

			$('.js-overlay-opening').fadeIn();

		} else {

			specific_overlayopening.start();

		}

		/*
		First toggle
		*/
		if(
			isFirstLoad == 1 &&
			url[1] !== 'akkers-in-nuenen'
		) {
			setTimeout(function() {
				specific_360.toggleInfo(1);
			},500);
		}

	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
		
	this.start = function() {
		
		/*
		Logo
		*/
		$('.js-header-logo').animate({
			'top':0
		},500);

		/*
		Overlay: Fadeout
		*/
		$('.js-overlay-opening').fadeOut();

		/*
		Open: Helpscherm
		*/
		if(url[3] !== '1000') {
			popup.open(0,1,'helpscherm');
		}

		/*
		First toggle
		*/
		setTimeout(function() {
			specific_360.toggleInfo('open');
		},500);

	};
		
}).apply(specific_overlayopening); 